<template>
   <div class="modal" v-show="show">
    <div class="modal-wrapper">
      <div :class="`modal-container ${customClass}`">
        <slot name="modal-header"></slot>  
        <slot name="modal-body"></slot>    
        <slot name="modal-footer"></slot>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Modal-Basic',
  props: {
    show: { type: Boolean, required: true },
    customClass: { type: String, default: ""}
  },
  data() {
    return {
      active: false
    }
  },
  methods: {
    closeModal () {
        this.$emit('closedModal', true)
    },
    click() {
      this.active =! this.active;
    }
  }
}
</script>